import './solutions.css';
import Button from '@mui/material/Button';
import { styled } from '@mui/material';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import SolutionsCard from './SolutionsCard';
import { useDevice } from '../../../contexts/DeviceContext';
import { getCurrentLayout } from '../../../utils/ChooseLayout';
import { HomePageApplicationsContent } from '../../../graphql/pimcore/modules/siteContent/types/HomePageContent';

export const LearnMoreButton = styled(Button)({
    fontFamily: 'Poppins',
    fontSize: '24px',
    lineHeight: '0.5rem',
    color: '#ffffff',
    textTransform: 'none',
});

type SolutionsProps = {
    cmsContent: HomePageApplicationsContent;
};

export default function Solutions({ cmsContent }: SolutionsProps) {
    const { width } = useDevice();
    const layout = getCurrentLayout(width);

    const getXsValue = (layout: string, index: number) => {
        if (layout === 'medium') {
            return index === 0 ? 4 : 4;
        } else if (layout === 'extra_small') {
            return index === 0 ? 12 : 12;
        } else {
            return index === 0 ? 6 : 6;
        }
    };

    const { title, mainText, segments } = cmsContent;

    return (
        <div className="contactUs-background">
            <div className="justify-between solutions-container">
                <div className="solutions-text-area">
                    <span className="self-start font_6 text_18">{title.content}</span>
                    <div className="flex-col self-stretch solutions-text">
                        <div
                            className="self-stretch font_10"
                            dangerouslySetInnerHTML={{
                                __html: mainText.sanitizedContent,
                            }}
                        />
                    </div>
                </div>
                <div className="div_cards">
                    <Box sx={{ flexGrow: 2 }}>
                        <Grid container spacing={3}>
                            {segments.entries.map((segment, index) => (
                                <Grid item xs={getXsValue(layout, index)} key={index}>
                                    <SolutionsCard applicationSegment={segment} />
                                </Grid>
                            ))}
                        </Grid>
                    </Box>
                </div>
            </div>
        </div>
    );
}
